/**
 * @generated SignedSource<<c69c9c7c6c072c9683958fd85c144ecd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternJobsCleanupMutation$variables = {
  days: number;
};
export type InternJobsCleanupMutation$data = {
  readonly cleanupOldJobs: {
    readonly deletedCount: number;
    readonly message: string;
  };
};
export type InternJobsCleanupMutation = {
  response: InternJobsCleanupMutation$data;
  variables: InternJobsCleanupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "days"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "days",
        "variableName": "days"
      }
    ],
    "concreteType": "JobCleanupResult",
    "kind": "LinkedField",
    "name": "cleanupOldJobs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternJobsCleanupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternJobsCleanupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c21670e6a31de10085947186af45c353",
    "id": null,
    "metadata": {},
    "name": "InternJobsCleanupMutation",
    "operationKind": "mutation",
    "text": "mutation InternJobsCleanupMutation(\n  $days: Int!\n) {\n  cleanupOldJobs(days: $days) {\n    deletedCount\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb2e4e2c1c4e2b626bdcd350bc1d67b0";

export default node;
